module.exports = __webpack_public_path__ + "static/media/IMG_5046.f19ff9d2.JPG";